import { configureStore } from "@reduxjs/toolkit"
import { combineReducers } from "redux"
import { persistStore, persistReducer } from "redux-persist"
import authReducer from "./auth/authSlice"
import initReducer from "./init/initReducer"
import userReducer from "./user/userReducer"
import questionBankReducer from "./questionBank/questionBankReducer"
import offersReducer from "./offers/offersReducer"
import examReducer from "./exam/examReducer"
import progressTrackerReducer from "./progressTracker/progressTrackerSlice"
import ordersReducer from "./orders/ordersSlice"
import subscriptionsReducer from "./subscriptions/subscriptionsSlice"
import emailLogsReducer from "./email-logs/emailLogsSlice"
import plansReducer from "./plans/plansSlice"
import questionFeedbackReducer from "./questionFeedback/questionFeedbackSlice"

const storage = {
  getItem: (key: string) => {
    try {
      const value = localStorage.getItem(key)
      return Promise.resolve(value)
    } catch (e) {
      return Promise.resolve(null)
    }
  },
  setItem: (key: string, value: string) => {
    try {
      localStorage.setItem(key, value)
      return Promise.resolve(value)
    } catch (e) {
      return Promise.resolve(null)
    }
  },
  removeItem: (key: string) => {
    try {
      localStorage.removeItem(key)
      return Promise.resolve()
    } catch (e) {
      return Promise.resolve()
    }
  },
}

const rootReducer = combineReducers({
  auth: authReducer,
  init: initReducer,
  user: userReducer,
  questionBank: questionBankReducer,
  progressTracker: progressTrackerReducer,
  offers: offersReducer,
  exam: examReducer,
  orders: ordersReducer,
  subscriptions: subscriptionsReducer,
  emailLogs: emailLogsReducer,
  plans: plansReducer,
  questionFeedback: questionFeedbackReducer,
})

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

export const persistor = persistStore(store)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
